module.exports = __webpack_public_path__ + "static/media/0.c741f012.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/accessoires/0.png
// module id = 374
// module chunks = 0